var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"cv-dropdown-item bx--dropdown-item bx--dropdown-link",on:{"click":function($event){return _vm.$emit('change', _vm.value)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }